import React, { forwardRef } from 'react';
import { TextStyle } from './Text.styles.js';
import styled from 'styled-components';
import { weightOptions, displayWeightOptions, bodySizeOptions, headingSizeOptions, displaySizeOptions, bodyTransformOptions, headingTransformOptions, displayTransformOptions } from './constants.js';

const defaultProps = {
    variant: 'body',
    sizing: 'medium',
    weight: 'regular',
    tagName: 'span',
};
const _Text = forwardRef((props, ref) => {
    const { children, sizing, // Used only in styling, prevent passing it to DOM
    tagName, transform, // Used only in styling, prevent passing it to DOM
    variant, // Used only in styling, prevent passing it to DOM
    weight, // Used only in styling, prevent passing it to DOM
    ...rest } = props;
    const Tag = tagName !== null && tagName !== void 0 ? tagName : 'span';
    return (React.createElement(Tag, { ref: ref, ...rest }, children));
});
_Text.displayName = '_Text';
const Text = styled(_Text).attrs(({ variant, sizing, transform, weight }) => {
    return {
        weight: variant === 'body' ||
            (variant === 'heading' &&
                weightOptions.includes(weight))
            ? weight
            : variant === 'display' &&
                displayWeightOptions.includes(weight)
                ? weight
                : defaultProps.weight,
        sizing: variant === 'body' &&
            bodySizeOptions.includes(sizing)
            ? sizing
            : variant === 'heading' &&
                headingSizeOptions.includes(sizing)
                ? sizing
                : variant === 'display' &&
                    displaySizeOptions.includes(sizing)
                    ? sizing
                    : defaultProps.sizing,
        transform: variant === 'body' &&
            bodyTransformOptions.includes(transform)
            ? transform
            : variant === 'heading' &&
                headingTransformOptions.includes(transform)
                ? transform
                : variant === 'display' &&
                    displayTransformOptions.includes(transform)
                    ? transform
                    : 'undefined',
    };
}) `
    ${TextStyle}
`;
Text.defaultProps = defaultProps;

export { Text, defaultProps };
//# sourceMappingURL=Text.js.map
